import { useEffect, useState } from "react";
import { Avatar, formatCreatedAt, formatDateTime } from "../../common/Functions";
import { ApiService } from "../../utils/ApiService";
import Pagination from "../../common/Pagination";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { capitalizeEachWord, eventStatus } from "../../utils/common";
import FullPageLoader from "../../common/FullPageLoader";

export default function HostDashboard({ host, setSelectedHost }) {
  const navigate = useNavigate();
  const [selectedDetails, setSelectedDetails] = useState({})
  const limit = 10;
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);

  const getHostDetail = async () => {
    const res = await ApiService.get(`admin/host-list?userId=${host._id}`)
    if (res.success) {
      setSelectedDetails(res)
      setLoading(false)
    }

  }
  useEffect(() => {
    getHostDetail()
  }, [])

  const handlePagination = (newPage) => {
    if (newPage >= 1 && newPage <= selectedDetails.pagination.totalPages) {
      setPage(newPage);
    }
  }
  return (
    <>
      {loading && <FullPageLoader />}
      <div className="bg-[#F5F5F5] min-h-screen">

        {/* Back button */}
        <button className="mb-4 flex items-center gap-2 text-black" onClick={() => setSelectedHost(null)}>
            <ArrowLeft
              className="w-6 h-6 mr-3 cursor-pointer text-gray-700"
            />
        </button>

        {/* Top Grid */}
        <div className="flex gap-6 mb-8">

        {/* Profile Card — FIXED WIDTH */}
        <div className="relative inline-flex items-center gap-4 
          bg-[#F8EEDA] border border-[#E4C778] rounded-2xl 
          px-6 py-5 shadow-sm 
          min-w-[398px] flex-shrink-0"
        >

          {/* Avatar Box */}
          <div className="p-3 rounded-[30px] bg-white shadow-sm inline-flex">
            <Avatar name={host.name} image={host.image} size={70} />
          </div>

          {/* Text Section */}
          <div className="flex-1">
            <div className="flex items-center justify-between">
              <div className="text-xl">
                {capitalizeEachWord(host.name)}
              </div>

              <span
                className="bg-[#FECE78] px-3 py-1 rounded-lg 
                  text-sm shadow-sm capitalize"
              >
                {capitalizeEachWord(host.userRole) || ""}
              </span>
            </div>
            <p className="text-sm text-gray-700">{host.email}</p>
            <p className="text-sm text-gray-700">
              Member since: {formatCreatedAt(host.createdAt)}
            </p>
          </div>
        </div>

        {/* STATS WRAPPER — FILLS REMAINING SPACE */}
        <div className="flex flex-1 gap-6">

          {/* Stat Card */}
          <div className="bg-white p-5 rounded-xl border border-gray-200 shadow-sm flex-1">
            <p className="text-sm text-gray-600">Total Events</p>
            <h2 className="text-[40px] font-bold text-blue-600">
              {selectedDetails?.pagination?.totalHostEvent || 0}
            </h2>
          </div>

          <div className="bg-white p-5 rounded-xl border border-gray-200 shadow-sm flex-1">
            <p className="text-sm text-gray-600">Total Attendees</p>
              <h2 className="text-[40px] font-bold text-green-600">
                {host?.totalAttendees || 0}
              </h2>
            </div>

            <div className="bg-white p-5 rounded-xl border border-gray-200 shadow-sm flex-1">
              <p className="text-sm text-gray-600">Total Revenue</p>
              <h2 className="text-[40px] font-bold text-orange-600">
                ${host?.totalRevenue || 0}
              </h2>
            </div>

          </div>
        </div>

        {/* Table */}
        <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-200">
          <table className="w-full">
            <thead className="bg-gray-200 text-m text-black">
              <tr>
                <th className="p-4 text-left font-normal">S. No</th>
                <th className="p-4 text-left font-normal">Event Name</th>
                <th className="p-4 text-left font-normal">Date & Time</th>
                <th className="p-4 text-left font-normal">Attendees</th>
                <th className="p-4 text-left font-normal">Revenue</th>
                <th className="p-4 text-left font-normal">Status</th>
              </tr>
            </thead>

            <tbody>
              {selectedDetails?.host && selectedDetails.host.length > 0 ? (
                selectedDetails.host.map((item, index) => (
                  <tr key={item?._id} className="border-t hover:bg-gray-50">
                    <td className="p-5 text-left text-[#4C4C4C] font-normal text-sm">{String(index + 1).padStart(2, "0")}</td>
                    <td className="p-5 text-left text-[#4C4C4C] font-normal text-sm">{item?.name}</td>
                    <td className="p-5 text-left text-[#4C4C4C] font-normal text-sm">{formatDateTime(item?.startTime)}</td>
                    <td className="p-5 text-left text-[#4C4C4C] font-normal text-sm">{item?.attendeeCount}</td>
                    <td className="p-5 text-left text-[#4C4C4C] font-normal text-sm">${item?.revenue || 0}</td>
                    <td className="p-5 text-left text-[#4C4C4C] font-normal text-sm">{eventStatus(item.startTime, item.endTime)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="p-4 text-center text-gray-500" colSpan={6}>
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {
          selectedDetails?.pagination?.totalPages > 1 && (

            <Pagination
            page={page}
            totalPages={selectedDetails?.pagination?.totalPages}
            totalItems={selectedDetails?.pagination?.totalPages}
            limit={limit||0}
            onPageChange={handlePagination}
            />
          )
        }
      </div>
    </>
  );
}
